import React from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from "yup";
import axios from "axios";
import { useNavigate } from 'react-router-dom';

function AddEvent() {
    let navigate = useNavigate();

    const initValues = {
        title: "",
        desc: "",
        image: "",
        eventdate: "",
    }

    const submit = async (data, { setSubmitting }) => {
        try {
            const formData = new FormData();
            formData.append("title", data.title);
            formData.append("desc", data.desc);
            formData.append("image", data.image);
            formData.append("eventdate", data.eventdate);

            await axios.post("https://bntserver.bntfoundation.com/EventPost.php", formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                }
            })
            window.location.href = '/eventlist';
        }
        catch (error) {
            console.error(error);
        }
        finally {
            setSubmitting(false);
        }
    }

    const validation = Yup.object().shape({
        title: Yup.string().required("Title is required"),
        desc: Yup.string().required("Description is required"),
        image: Yup.string().required("Image is required"),
        eventdate: Yup.date().required("Event date is required"),
    })

    return (
        <div>
            <h2>Add Event</h2>
            <Formik initialValues={initValues} onSubmit={submit} validationSchema={validation}>
                {({ values, setFieldValue, isSubmitting }) => (
                    <Form>
                        <div className="form-horizontal">
                            <div className="form-group">
                                <label className="control-label col-md-2">Title</label>
                                <div className="col-md-10">
                                    <ErrorMessage name="title" component="span" className='text-danger' />
                                    <Field
                                        name="title"
                                        className="form-control"
                                    />
                                </div>
                            </div>

                            <div className="form-group">
                                <label className="control-label col-md-2">Description</label>
                                <div className="col-md-10">
                                    <ErrorMessage name="desc" component="span" className='text-danger' />
                                    <Field
                                        name="desc"
                                        className="form-control"
                                        as="textarea"
                                        rows="4"
                                    />
                                </div>
                            </div>

                            <div className="form-group">
                                <label className="control-label col-md-2">Event Image</label>
                                <div className="col-md-10">
                                    <div className='my-1'>
                                        <ErrorMessage name="image" component="span" className='text-danger' />
                                    </div>
                                    <input 
                                        type="file" 
                                        name="image" 
                                        onChange={(event) => {
                                            setFieldValue("image", event.target.files[0]);
                                        }} 
                                    />
                                </div>
                            </div>

                            <div className="form-group">
                                <label className="control-label col-md-2">Event Date</label>
                                <div className="col-md-10">
                                    <ErrorMessage name="eventdate" component="span" className='text-danger' />
                                    <Field
                                        type="date"
                                        name="eventdate"
                                        className="form-control"
                                    />
                                </div>
                            </div>

                            <div className="form-group">
                                <div className="col-md-offset-2 col-md-10">
                                    <input 
                                        type="submit" 
                                        disabled={isSubmitting} 
                                        value="Submit" 
                                        className="btn btn-secondary" 
                                    />
                                </div>
                            </div>
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    )
}

export default AddEvent; 